/**
 * CheckoutStepLicense Component
 */
/* tslint:disable:no-submodule-imports */

import tr from '../../../locales';
import { consumeLocallyStoredStep } from '../../../redux/actions/checkout';
import { validateEmail } from '../../../utils/string';

import { extend, get, isEmpty, sortBy } from 'lodash';
import * as React from 'react';
import { connect } from 'react-redux';
import { Field, FormProps, reduxForm } from 'redux-form';

import { FieldEmail } from '../../../redux/form/utils';
import Heading from '../../atoms/text/Heading';
import FormCell from '../../molecules/forms/FormCell';
import FormRow from '../../molecules/forms/FormRow';
import Select from '../../molecules/forms/Select';
import TextField from '../../molecules/forms/TextFieldWithLabel';
import AddressForm, { getAddressFormValidations } from '../../organisms/forms/AddressForm';
import CheckoutStep from './CheckoutStep';
import { CheckoutStepFormName, CheckoutStepId } from './config';

type IOwnStateProps = Pick<CheckoutStepLicenseProps, 'initialValues'>;

interface IOwnMergedProps {
  consumeLocalStorage: () => void;
}

interface IOwnProps {
  representativeRoles: GQL.IRepresentativeRoleConnection;
}

type CheckoutStepLicenseProps = IOwnProps & IOwnMergedProps & FormProps<any, any, {}>;

interface IFormFields {
  address: IAddress;
  representative: {
    name?: string;
    email?: string;
    phone?: string;
    role?: string;
  };
}

export type CheckoutStepLicenseFormFields = IFormFields;

const stepId = CheckoutStepId.license;
const form = CheckoutStepFormName.license;
const formValidations: IFormValidations = extend({
  'representative.email': {
    validator: validateEmail,
    error: tr.validations.email,
  },
  'representative.role': {
    error: 'Please select the authorized representative role.',
  },
}, getAddressFormValidations());

class CheckoutStepLicense extends React.Component<CheckoutStepLicenseProps, {}> {

  representativeRolesForSelect: Array<{ value: string; label: string; }>;

  constructor(props: CheckoutStepLicenseProps) {
    super(props);

    this.representativeRolesForSelect = props.representativeRoles.edges!.map(({ node }) => {
      return {
        value: node!.id,
        label: node!.name!,
      };
    });

    this.representativeRolesForSelect = sortBy(this.representativeRolesForSelect, 'label');
  }

  componentDidMount() {
    this.props.consumeLocalStorage();
  }

  render() {
    const {
      error,
      handleSubmit,
      submitting,
    } = this.props;

    return (
      <CheckoutStep
        error={error}
        formValidations={formValidations}
        id={stepId}
        handleSubmit={handleSubmit!}
        submitting={submitting}
        title="Licensee Information"
      >
        <div>
          <Heading is="h5">Tell us about your company.</Heading>
          <AddressForm form={form} />
        </div>
        <div>
          <Heading is="h5">Authorized Representative</Heading>
          <FormRow>
            <FormCell minimumWidth="full">
              <Field
                name="representative.name"
                component={TextField}
                label="Name"
                colorScheme="light"
              />
            </FormCell>
          </FormRow>
          <FormRow>
            <FormCell minimumWidth="full">
              <Select
                form={form}
                label="Role"
                name="representative.role"
                options={this.representativeRolesForSelect}
                selectName="representative-role-select"
                selectProps={{
                  autoBlur: true,
                  clearable: false,
                }}
              />
            </FormCell>
          </FormRow>
          <FormRow>
            <FormCell minimumWidth="full">
              <FieldEmail
                name="representative.email"
                component={TextField}
                label="Email address"
                colorScheme="light"
                onlyValidateIfTouched
              />
            </FormCell>
          </FormRow>
          <FormRow>
            <FormCell minimumWidth="full">
              <Field
                name="representative.phone"
                component={TextField}
                label="Phone Number"
                colorScheme="light"
                optional
              />
            </FormCell>
          </FormRow>
        </div>
      </CheckoutStep>
    );
  }
}

const CheckoutStepLicenseForm = reduxForm<IFormFields, CheckoutStepLicenseProps, any>({
  form,
})(CheckoutStepLicense);

const ConnectedCheckoutStepLicense = connect(
  ({ checkout: { localStorage } }: IStoreState, ownProps: IOwnProps): IOwnStateProps => ({
    initialValues: localStorage && get(localStorage, stepId, {}),
  }),
  (dispatch): IOwnMergedProps => ({
    consumeLocalStorage: () => dispatch(consumeLocallyStoredStep({ id: stepId })),
  }),
  (stateProps, dispatchProps, ownProps): CheckoutStepLicenseProps => ({
    ...ownProps,
    ...stateProps,
    consumeLocalStorage: () => !isEmpty(stateProps.initialValues) && dispatchProps.consumeLocalStorage(),
  }),
)(CheckoutStepLicenseForm);

export default ConnectedCheckoutStepLicense;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/pages/Checkout/CheckoutStepLicense.tsx